import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import {
  Card,
  CardHeader,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import WDBox from "../../../MaterialComponents/WDBox";
import WDTypography from "../../../MaterialComponents/WDTypography";
import { FORMAT_DATE } from "../../../Configurations/JsUtil";
import { getAuthToken } from "../../../utils/authUtils";

const MyTickets = () => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const appStore = useSelector((state) => state.app);
  const { apiUrl } = appStore;

  useEffect(() => {
    fetchMyTickets();
  }, []);

  const fetchMyTickets = async () => {
    try {
      setLoading(true);
      const authToken = getAuthToken();
      if (!authToken) {
        throw new Error("Authentication token not found");
      }

      const response = await axios.get(`${apiUrl}/v1/ticket/myTickets`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      setTickets(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching tickets:", error);
      setError("Failed to load tickets. Please try again later.");
      setLoading(false);
    }
  };

  const renderTicketStatus = (status) => {
    let color = "info";
    switch (status) {
      case "OPEN":
        color = "info";
        break;
      case "ASSIGNED":
        color = "warning";
        break;
      case "TAKEN":
        color = "warning";
        break;
      case "COMPLETED":
        color = "success";
        break;
      case "CLOSED":
        color = "success";
        break;
      case "REJECTED":
        color = "error";
        break;
      default:
        color = "info";
    }

    return (
      <WDTypography variant="caption" color={color} fontWeight="medium">
        {status}
      </WDTypography>
    );
  };

  return (
    <WDBox py={3}>
      <Card>
        <CardHeader
          title={
            <WDTypography variant="h5" fontWeight="medium">
              My Tickets
            </WDTypography>
          }
          subheader={
            <WDTypography variant="body2" color="text">
              View all tickets created for you
            </WDTypography>
          }
        />
        <CardContent>
          {loading ? (
            <Box display="flex" justifyContent="center" p={3}>
              <CircularProgress />
            </Box>
          ) : error ? (
            <Typography color="error" align="center">
              {error}
            </Typography>
          ) : tickets.length === 0 ? (
            <Typography align="center">No tickets found.</Typography>
          ) : (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Ticket Number</TableCell>
                    <TableCell>Service</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Created Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tickets.map((ticket) => (
                    <TableRow key={ticket.id}>
                      <TableCell>{ticket.ticketNumber}</TableCell>
                      <TableCell>{ticket.serviceName || "N/A"}</TableCell>
                      <TableCell>{ticket.description || "N/A"}</TableCell>
                      <TableCell>{renderTicketStatus(ticket.status)}</TableCell>
                      <TableCell>
                        {FORMAT_DATE(ticket.createdDate) || "N/A"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </CardContent>
      </Card>
    </WDBox>
  );
};

export default MyTickets;
